<script setup lang="ts">
import { Button, Checkbox, FormField } from "@soft-db/ui";
import AppDialog from "../common/AppDialog.vue";

defineProps<{
	title?: string;
	description?: string;
}>();

const { t } = useI18n();

const { isRevealed, reveal: _reveal, confirm, cancel } = useConfirmDialog();
const confirmCheckbox = ref(false);
function handleAction() {
	if (confirmCheckbox.value) {
		confirm();
	}
}

const updatedList = ref<any[]>([]);
const shouldDisplayConfirmation = computed(() => updatedList.value.length > 0);

function reset() {
	confirmCheckbox.value = false;
	updatedList.value = [];
}

function initConfirmation(list: any[]) {
	reset();
	updatedList.value = list;
}

function reveal(list: any[]) {
	initConfirmation(list);

	if (shouldDisplayConfirmation.value) {
		return _reveal();
	} else {
		return { isCanceled: false };
	}
}

defineExpose({ reveal });
</script>

<template>
	<AppDialog
		class="md:min-w-200"
		:modelValue="isRevealed"
		:actionText="t('common.save')"
		:actionDisabled="!confirmCheckbox"
		persistent
		@click:action="handleAction"
		@update:modelValue="(v) => !v && cancel()"
	>
		<template #title>{{ t("common.changesRequireAttention") }}</template>
		<template #content>
			<div v-if="updatedList.length > 0" class="flex flex-col gap-1">
				<h3 v-if="title">{{ title }}</h3>
				<span v-if="description">{{ description }}</span>

				<slot />

				<FormField class="mt-1" :label="t('common.confirmInteractive')" labelPosition="right">
					<Checkbox v-model="confirmCheckbox" />
				</FormField>
			</div>
		</template>

		<template #close>
			<Button variant="soft" @click="cancel">{{ t("common.cancel") }}</Button>
		</template>
		<template #action>
			<Button variant="soft" color="warning" :disabled="!confirmCheckbox" @click="confirm">
				{{ t("common.save") }}
			</Button>
		</template>
	</AppDialog>
</template>
